<div class="inline-flex items-center gap-1">
  <elcia-button
    (onClick)="previous()"
    [icon]="'chevron-left'"
    variant="text"
  />

  <span
    (click)="menu.toggle($event)"
    class="min-w-[200px] text-center font-semibold text-gray-800 capitalize select-none cursor-pointer"
  >
    {{ label() }}
  </span>

  <p-menu #menu [model]="menuItems()" [popup]="true">
    <ng-template #item let-item>
      <a
        (click)="selectType(item.value); menu.hide()"
        class="p-menu-item-link cursor-pointer capitalize"
      >
        {{ item.label | translate }}
      </a>
    </ng-template>
  </p-menu>

  <elcia-button
    (onClick)="next()"
    [icon]="'chevron-right'"
    variant="text"
  />
</div>
